import { createSlice } from "infrastructure/store/lib";
import { sliceMixin } from "infrastructure/store/reducers";
import {
    exportSetupsRequestLoading,
    setupByIdRequestFulfilled,
    setupByIdRequestLoading,
    setupByIdRequestRejected,
    setupsRequestFulfilled,
    setupsRequestLoading,
    setupsRequestRejected,
    updateOrCreateSetupRequestFulfilled,
    deleteSetupRequestFulfilled
} from "./reducers";
import initialState, { sliceToken } from "./state";
import {
    getSetupByIdentifierThunk,
    getSetupsThunk,
    updateOrCreateSetupThunk,
    deleteSetupThunk
} from "./thunks";
import type { SetupsState } from "./types";

const slice = createSlice({
    name: sliceToken,
    initialState,
    reducers: {
        ...sliceMixin<SetupsState>(initialState),
        changeSetupsExportLoading: exportSetupsRequestLoading
    },
    extraReducers: builder =>
        builder
            // Get General Setups
            .addCase(getSetupsThunk.pending, setupsRequestLoading)
            .addCase(getSetupsThunk.fulfilled, setupsRequestFulfilled)
            .addCase(getSetupsThunk.rejected, setupsRequestRejected)
            // Get Setup by Identifier
            .addCase(getSetupByIdentifierThunk.pending, setupByIdRequestLoading)
            .addCase(getSetupByIdentifierThunk.fulfilled, setupByIdRequestFulfilled)
            .addCase(getSetupByIdentifierThunk.rejected, setupByIdRequestRejected)
            // Update or Create General Setup
            .addCase(updateOrCreateSetupThunk.pending, setupsRequestLoading)
            .addCase(updateOrCreateSetupThunk.fulfilled, updateOrCreateSetupRequestFulfilled)
            .addCase(updateOrCreateSetupThunk.rejected, setupsRequestRejected)
            // Delete General Setup
            .addCase(deleteSetupThunk.pending, setupsRequestLoading)
            .addCase(deleteSetupThunk.fulfilled, deleteSetupRequestFulfilled)
            .addCase(deleteSetupThunk.rejected, setupsRequestRejected)
});

export const {
    name,
    actions: {
        changeSetupsExportLoading
    }
} = slice;

export default slice.reducer;